import { render, staticRenderFns } from "./NotificationApiView.vue?vue&type=template&id=f224ed96&"
import script from "./NotificationApiView.vue?vue&type=script&lang=ts&"
export * from "./NotificationApiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports